/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliAttendanceDto } from '../../models/amoxcalli-attendance-dto';

export interface ApiAttendanceStudentGet$Plain$Params {
  studentId?: string;
  groupId?: string;
}

export function apiAttendanceStudentGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAttendanceStudentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliAttendanceDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAttendanceStudentGet$Plain.PATH, 'get');
  if (params) {
    rb.query('studentId', params.studentId, {});
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliAttendanceDto>>;
    })
  );
}

apiAttendanceStudentGet$Plain.PATH = '/api/attendance/student';
